import React, {useState} from "react";
import ImgMetro from "../assets/img-metro.webp";
import LogoMetro from "../assets/logo-metro.svg";
import DownloadButton from "../components/download-button";
import {WIDGET_DISPLAY_TYPES} from "../utils/constants";
import DataWidget from "../components/data-widget";
import DownloadForm from "../components/download-form";

const PAGE_CONTENT = {
  en: {
    bmrcl: "Namma Metro",
    text: "Schedules, routes, stops, and fare data for metro trains in Bengaluru.",
    last: "Last updated: 19 July 2024 17:00:00",
  },
  kn: {
    bmrcl: "ನಮ್ಮ ಮೆಟ್ರೋ",
    text: "ಬೆಂಗಳೂರಿನಲ್ಲಿ ಮೆಟ್ರೋ ರೈಲುಗಳ ವೇಳಾಪಟ್ಟಿಗಳು, ಮಾರ್ಗಗಳು, ನಿಲ್ದಾಣಗಳು ಮತ್ತು ದರದ ಡೇಟಾ.",
    last: "ನವೀಕರಿಸಲಾಗಿದೆ: 19 ಜುಲೈ 2024 17:00:00",
  },
};

const DataWidgetBmrcl = () => {
  const selectedLang = typeof window !== "undefined" ? window.localStorage.getItem("lang") || "en" : "en";
  const [showDownload, setShowDownload] = useState(false);
  return (
    <>
      {
        showDownload && (
          <DownloadForm
            onCloseClick={() => setShowDownload(false)}
            bmrcl={true}
          />
        )
      }
      <div className="section long reverse mobile-reverse">
        <div className="section-small" style={{backgroundImage: `url(${ImgMetro})`}}/>
        <div className="section-large auto-height">
          <div className="widget-info">
            <img src={LogoMetro} alt="BMTC logo" className="widget-logo"/>
            <div className="widget-info-content">
              <h3>{PAGE_CONTENT[selectedLang].bmrcl}</h3>
              <p>{PAGE_CONTENT[selectedLang].text}</p>
            </div>
            {/*<DownloadButton onClick={() => setShowDownload(true)} />*/}
          </div>
          <DataWidget
            type="bmrcl"
            defaultDisplay={WIDGET_DISPLAY_TYPES.table}
            files={["agency.txt", "calendar.txt", "calendar_dates.txt", "fare_attributes.txt", "fare_rules.txt", "feed_info.txt", "routes.txt", "shapes.txt", "stop_times.txt", "stops.txt", "transfers.txt", "translations.txt", "trips.txt"]}
            lastUpdated={PAGE_CONTENT[selectedLang].last}
          />
        </div>
      </div>
    </>
  );
};

export default DataWidgetBmrcl;
